import React from 'react'
import Appbar from 'components/Appbar'
import { PageContent, ModalLayer } from '@ui'
import { Router, RouteComponentProps } from '@reach/router'
import Tableview from './Tableview'
import useDepartments from './hooks/useDepartments'
import DepartmentSearch from './DepartmentSearch'

export default function DepartmentManagement({ navigate }: RouteComponentProps) {
  const departments = useDepartments()
  return (
    <>
      {/* eslint-disable @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Router primary={false} navigate={navigate}>
        <ModalLayer path="*" />
      </Router>
      <Appbar title="Departments">
        <DepartmentSearch hook={departments} navigate={navigate} />
      </Appbar>
      <PageContent>
        <Tableview
          navigate={navigate}
          hook={departments}
          clearFilter={() => {
            departments.search('')
          }}
        />
      </PageContent>
    </>
  )
}
